export default function InvestimentoSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="max-w-3xl mx-auto bg-background-50 border border-background-200/70 rounded-3xl p-8 md:p-14 text-center">
          <div className="inline-flex items-center gap-3 bg-white border border-background-200/70 rounded-full px-5 py-2.5 mb-7">
            <i className="ri-arrow-right-up-line text-primary-500 text-lg"></i>
            <span className="text-foreground-800 text-[14px] font-medium">
              Atendimento prioritário para projetos{' '}
              <span className="text-primary-600 font-semibold">a partir de R$ 50 mil</span>
            </span>
          </div>

          <h2 className="text-foreground-950 text-[24px] md:text-[34px] font-semibold tracking-tight leading-tight mb-6">
            Soluções para projetos corporativos de maior porte.
          </h2>

          <p className="text-foreground-600 text-[14px] md:text-[16px] leading-relaxed max-w-2xl mx-auto mb-5">
            O investimento depende da quantidade de ambientes, número de usuários, produtos,
            acabamentos, cidade e serviços envolvidos.
          </p>

          <p className="text-foreground-500 text-[13px] md:text-[14px] leading-relaxed max-w-2xl mx-auto">
            Nosso foco é atender empresas que procuram uma solução profissional e estruturada —
            não apenas a compra avulsa de um item.
          </p>
        </div>
      </div>
    </section>
  );
}